// #region imports

// --- Angular
import { Component, Input, Output, EventEmitter } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent {

  alertState = {
    show: true,
  };

  @Input()
  set show(value: boolean) {
    this.alertState.show = value;
  }

  @Input() title: string;
  @Input() content: string;
  @Input() callToActionText: string;

  @Output() callToAction = new EventEmitter();
  @Output() closed = new EventEmitter();

  constructor() { }

  onClose() {
    this.alertState.show = false;
    this.closed.emit();
  }

  onCallToActionClick() {
    this.callToAction.emit();
  }

}
